/**
 * SIM-18 / ACS-4355 — folder-scoped EN locale for the /reset-password full
 * page state machine. Keys are the union of SIM-1 `pages/Auth/locales
 * /ResetPassword_en_US`, `components/GlobalModals/ForgotPasswordModal
 * /locales/ForgotPasswordModal_en_US`, `components/GlobalModals
 * /ResetPasswordConfirmationModal/locales/ResetPasswordConfirmationModal
 * _en_US`, and `components/ResetPassword/locales/ResetPassword_en_US`. FR
 * pair MUST list every key here (P5-L1).
 */
const resources = {
    // Shell / traditional form (SIM-1 preserved)
    pageTitle: 'Reset Password',
    pageDescription: 'To reset your password, enter your email address below. We will then send an email containing a link to reset your password.',
    emailPlaceholder: 'Email address',
    emailRequired: 'Please enter your email address',
    sendResetLinkButton: 'Send Email',
    backToSignIn: 'Back to Sign In',
    stillHavingTrouble: 'Still having trouble?',
    unableToResetPassword: 'If you’re unable to reset your password, please call Customer Service at',
    phoneNumber: '(1-877-737-4672)',
    forAssistance: 'Deaf and Hard-of-Hearing/TTY see',
    accessibility: 'Accessibility',
    fallbackErrorMsg: 'If you’re unable to reset your password, please call Customer Service at 1-877-SEPHORA.',
    confirmButton: 'OK',
    // AC-040 verbatim copy — must match `\'` (ASCII apostrophe) exactly; SIM-1
    // `ResetPassword.failure.test.jsx` pins the string via `AC_040_MESSAGE`.
    emailSendFailed: 'We couldn\'t send a reset email. Check your email address or contact customer service.',

    // Passkey-first landing (Phase 3)
    forgotYourPasswordTitle: 'Forgot your password? Switch to face or fingerprint for a faster and safer sign in',
    passkeysIntroMessage: 'Sephora is switching to passkeys to make your Sign In faster. We never receive your biometric data like fingerprints or face scans.',
    sharedDeviceDisclaimer: 'Not advised for shared devices.',
    termsAndConditions: 'By clicking "Continue", you (1) agree to the current version of our ',
    termsOfUse: 'TERMS OF USE',
    termsAndConditionsRest: ', and (2) have read Sephora’s ',
    privacyPolicy: 'Privacy Policy',
    continueButton: 'Continue',
    resetMyPasswordCta: 'Reset My Password',
    errorPasskeyMaxAttempts: 'You have exceeded the maximum number of passkey reset attempts. Please try again later.',
    passkeysInfoLabel: 'More info about passkeys',

    // Email-sent confirmation (Phase 4)
    emailSent: 'Email Sent',
    confirmationMessage: 'We have sent an email to',
    confirmationMessage2: 'Please check your inbox and click on the link to reset your password.',
    confirmationMessagePasskey: 'Please check your inbox and click on the link to create your passkey.',
    didntGetEmail: 'Didn’t get the email? Check your spam folder or',
    resend: 'resend',
    errorMessage: 'Something went wrong, and we could not resend the email. Please try again later.',

    // Set-new-password + reset success (Phase 4)
    pleaseCreateNewPassword: 'Please create a new password (6-12 characters long) to access your account.',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    confirmError: 'The passwords you entered do not match. Please fix to continue.',
    resetPasswordButton: 'Reset Password',
    resetSuccessful: 'Reset Successful',
    passwordHasBeenReset: 'Your password has been reset and you will be receiving an email confirmation soon.',
    viewProfileButton: 'View Profile',
    backToHomepageButton: 'Back to Homepage',

    // Token error (Phase 4)
    resetLinkExpiredTitle: 'Reset Link Expired',
    resetLinkExpired: 'Your reset password link has expired or is invalid. Please try again.',

    // Passkey creation from email (Scenario 11)
    createPasskeyTitle: 'Create your passkey',
    createPasskeyBody: 'Continue below to create a passkey for faster and safer sign in on this device.',
    passkeyCreationFailed: 'We couldn’t create your passkey. Try again, or reset your password instead.'
};

export default function getResource(label) {
    return resources[label];
}
